import type { MovementClass, TargetClass } from '../types/primitives'

export interface TowerTargetingView {
  targetClass: TargetClass
}

export interface EnemyTargetingView {
  movementClass: MovementClass
}

/**
 * Central target eligibility — do not scatter AIR checks in targeting modes.
 * FIRST/LAST/STRONG/WEAK operate only over eligible targets.
 */
export function canTowerTargetEnemy(
  tower: TowerTargetingView,
  enemy: EnemyTargetingView
): boolean {
  const tc = tower.targetClass
  const mc = enemy.movementClass
  if (tc === 'BOTH') return true
  if (tc === 'GROUND') return mc === 'GROUND'
  if (tc === 'AIR') return mc === 'AIR'
  return false
}
